import { useLocalStorage } from '@uidotdev/usehooks';
import { useRegisterRoute } from '@/registration/hook/useRegisterRoute';
import { useEffect } from 'react';
import bugsnag from '@/bugsnag';

export interface UserSession {
  email: string
  client: string
  authToken: string
}

export function useUserSession() {
  const { tenantCode } = useRegisterRoute();

  const [userSession, setUserSession] = useLocalStorage<UserSession | undefined>(`userSession_${tenantCode}`);

  useEffect(() => {
    bugsnag.setContext(tenantCode);
  }, [tenantCode]);
  useEffect(() => {
    bugsnag.setUser(userSession?.email, userSession?.email); // Bugsnap: set id = null to clear user
  }, [userSession]);

  return {
    userSession,
    setUserSession,
  };
}
